import { v4 as uuid } from 'uuid';
import { PHONE_OPTIONS } from '../form/helper';

export function phoneNumberChange(id, newValue, field, phoneNumbers) {
  return phoneNumbers.map((phoneNumber) => {
    if (phoneNumber.id === id || phoneNumber.uuid === id) {
      return { ...phoneNumber, [field]: newValue };
    }

    return phoneNumber;
  });
}

function generatePhoneNumber() {
  return {
    uuid: uuid(),
    label: PHONE_OPTIONS[0],
    number: '',
    primary: false
  };
}

export function addNumber(phoneNumbers) {
  return [...phoneNumbers, generatePhoneNumber()];
}

export function changePrimary(id, makePrimary, phoneNumbers) {
  if (makePrimary) {
    return phoneNumbers.map((phoneNumber) => {
      return { ...phoneNumber, primary: phoneNumber.id === id || phoneNumber.uuid === id };
    });
  } else {
    return phoneNumbers.map((phoneNumber) => {
      if (phoneNumber.id === id || phoneNumber.uuid === id) {
        return { ...phoneNumber, primary: false };
      }

      return phoneNumber;
    });
  }
}

export function deleteNumber(id, phoneNumbers) {
  return phoneNumbers.reduce((accumulator, phoneNumber) => {
    if (phoneNumber.id === id) {
      accumulator.push({ ...phoneNumber, _destroy: true });
    } else if (phoneNumber.uuid !== id) {
      accumulator.push(phoneNumber);
    }
    return accumulator;
  }, []);
}
